import { Button, Table, Space, Drawer, Form, Steps } from 'antd';
import { observer } from 'mobx-react';
import PropertyComponent from './PropertyComponent';
import { useEffect, useState } from 'react';
import useStore from '../../../../store';
import {
	displayFormats,
	Notification,
	PropertySteps,
} from '../../../../config/Global';
import moment from 'moment';
import Message from '../../../../config/Message';
import dayjs from 'dayjs';
import DeletePropertyComponent from './DeletePropertyComponent';
import RoomCategoryForm from './RoomCategoryComponent';
import PropertyImageUpload from './PropertyImageUpload';
import RoomCategoryImageUpload from './RoomCategoryImageUploadComponent';
import PropertyImageApproveModal from './PropertyImageApprove';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage } from '@fortawesome/free-solid-svg-icons';

const AddAccommodationDetail = observer((props) => {
	const { openImageModal } = props;
	const [addModel, setAddModel] = useState(false);
	const [form] = Form.useForm();
	const { ACCOMMODATION, AUTH } = useStore();
	const {
		propertyDetail,
		roomCategoryDetail,
		propertyImageDetails,
		roomCategoryImageDetails,
		roomCategoryLookup,
	} = ACCOMMODATION;
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [formID, setFormID] = useState('PropertyForm');
	const [propertyID, setPropertyID] = useState(null);
	const [roomCategoryId, SetRoomCategoryId] = useState(null);
	const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);
	const [current, setCurrent] = useState(0);
	const [fileLists, setFileLists] = useState({});
	const [propertyImageModal, setPropertyImageModal] = useState(false);
	const [descriptionValue, setDescriptionValue] = useState('');
	// const [faQsValue, setfaQsValue] = useState('');
	// const [SEOData, setSEOData] = useState({
	// 	metaTitle:
	// 		'propertyName | Hotel and Dharamshala detail | BookingDham.org',
	// 	metaKeywords: 'propertyName in cityName, propertyName in stateName',
	// 	metaDescription: 'propertyName in cityName. hotelORdharmshala',
	// });
	const [disabledDefault, setDisabledDefault] = useState();
	const {
		AUTH: { stateList, cityList, lookupKeyList },
	} = useStore();
	const [propertyNamee, setPropertyName] = useState();
	const [stateName, setStateName] = useState();
	const [cityName, setCityName] = useState();
	const [hotelORDharmshalaName, setHotelORDharmshalaName] = useState();
	// const [isChecked, setIsChecked] = useState(false);

	const showDeleteModal = (data) => {
		setIsDeleteModalVisible(data);
	};

	const handleDeleteModalClose = () => {
		setIsDeleteModalVisible(false);
	};

	const openImage = (data) => {
		setPropertyImageModal(data.id);
	};

	const closeImageModal = () => {
		setPropertyImageModal(false);
	};

	const handleChange = async () => {
		if (formID === 'PropertyImageUpload') {
			setTimeout(() => {
				const propertyImageList =
					form.getFieldValue('propertyImageList') || [];
				const selectedImageTypes =
					propertyImageList.length &&
					propertyImageList
						.map((item) => item?.ImageType)
						.filter((type) => type !== undefined && type !== null);
				if (selectedImageTypes) {
					setDisabledDefault(selectedImageTypes.includes(3) ? 3 : 0);
				}
				form.validateFields({ validateOnly: true })
					.then(() => {
						if (form.getFieldsValue().propertyImageList.length) {
							if (
								form.getFieldsValue().propertyImageList
									.length === Object.keys(fileLists).length
							) {
								setDisabled(false);
							} else {
								setDisabled(true);
							}
						} else {
							setDisabled(true);
						}
					})
					.catch(() => {
						// setDisabled(true);
					});
			});
		} else if (formID === 'RoomCategoryImageUpload') {
			const roomCategoryImageList =
				form.getFieldValue('roomCategoryImageList') || [];
			const selectedImageTypes =
				roomCategoryImageList.length &&
				roomCategoryImageList
					.map((item) => item?.ImageType)
					.filter((type) => type !== undefined && type !== null);
			if (selectedImageTypes) {
				setDisabledDefault(selectedImageTypes.includes(3) ? 3 : 0);
			}
			if (
				roomCategoryId === null ||
				roomCategoryId !== form.getFieldsValue().RoomCategoryId
			) {
				setFileLists({});
				SetRoomCategoryId(form.getFieldsValue().RoomCategoryId);
				await handleImageUploadRoomCategoryScreen();
			}

			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(async () => {
						if (
							form.getFieldsValue().roomCategoryImageList.length
						) {
							if (
								form.getFieldsValue().roomCategoryImageList
									.length === Object.keys(fileLists).length
							) {
								setDisabled(false);
							} else {
								setDisabled(true);
							}
						} else {
							setDisabled(true);
						}
					})
					.catch(() => {
						// setDisabled(true);
					});
			});
		} else {
			setTimeout(() => {
				form.validateFields({ validateOnly: true })
					.then(async () => {
						setDisabled(false);
					})
					.catch((err) => {
						setDisabled(true);
					});
			}, 0);
		}
	};

	// const testBlurEv = () => {
	// 	const {
	// 		propertyName,
	// 		eCityId,
	// 		eStateId,
	// 		metaTitle,
	// 		metaDescription,
	// 		metaKeywords,
	// 		propertyType,
	// 	} = form.getFieldsValue();
	// 	if (addModel === 'add') {
	// 		let getStateName =
	// 			stateList && stateList.length
	// 				? stateList.find((_X) => _X.eRegionId === eStateId)
	// 					?.regionName
	// 				: 'stateName';

	// 		let getCityName =
	// 			cityList && cityList.length
	// 				? cityList.find((_X) => _X.eRegionId === eCityId)
	// 					?.regionName
	// 				: 'cityName';

	// 		let hotelORdharmshalaNamee =
	// 			lookupKeyList && lookupKeyList.length
	// 				? propertyType
	// 					? lookupKeyList.find(
	// 						(_x) => _x.lookupIntValue === propertyType
	// 					).lookupValue
	// 					: 'hotelORdharmshala'
	// 				: 'hotelORdharmshala';

	// 		let metaKeywordsdd = metaKeywords;
	// 		metaKeywordsdd = metaKeywordsdd.replace(
	// 			stateName ? stateName : 'stateName',
	// 			getStateName || 'stateName'
	// 		);

	// 		metaKeywordsdd = metaKeywordsdd.replace(
	// 			cityName ? cityName : 'cityName',
	// 			getCityName || 'cityName'
	// 		);
	// 		metaKeywordsdd = metaKeywordsdd.replace(
	// 			new RegExp(propertyNamee ? propertyNamee : 'propertyName', 'g'),
	// 			propertyName || 'propertyName'
	// 		);

	// 		let metaDescriptionn = metaDescription;
	// 		metaDescriptionn = metaDescriptionn.replace(
	// 			new RegExp(propertyNamee ? propertyNamee : 'propertyName', 'g'),
	// 			propertyName || 'propertyName'
	// 		);
	// 		metaDescriptionn = metaDescriptionn.replace(
	// 			cityName ? cityName : 'cityName',
	// 			getCityName || 'cityName'
	// 		);
	// 		metaDescriptionn = metaDescriptionn.replace(
	// 			hotelORDharmshalaName
	// 				? hotelORDharmshalaName
	// 				: 'hotelORdharmshala',
	// 			hotelORdharmshalaNamee || 'hotelORdharmshala'
	// 		);
	// 		form.setFieldsValue({
	// 			metaTitle: metaTitle.replace(
	// 				new RegExp(
	// 					propertyNamee ? propertyNamee : 'propertyName',
	// 					'g'
	// 				),
	// 				propertyName || 'propertyName'
	// 			),
	// 			metaDescription: metaDescriptionn,
	// 			metaKeywords: metaKeywordsdd,
	// 		});
	// 		setPropertyName(propertyName);
	// 		setStateName(getStateName);
	// 		setCityName(getCityName);
	// 		setHotelORDharmshalaName(hotelORdharmshalaNamee);
	// 	} else {
	// 		let getStateName = stateList.find(
	// 			(_X) => _X.eRegionId === eStateId
	// 		)?.regionName;
	// 		let getCityName = cityList.find(
	// 			(_X) => _X.eRegionId === eCityId
	// 		)?.regionName;
	// 		let hotelORdharmshalaNamee = propertyType
	// 			? lookupKeyList.find((_x) => _x.lookupIntValue === propertyType)
	// 				.lookupValue
	// 			: propertyDetail.propertyTypeName;
	// 		let metaKeywordsdd = metaKeywords || '';
	// 		metaKeywordsdd = metaKeywordsdd.replace(
	// 			stateName ? stateName : propertyDetail.stateName,
	// 			getStateName || propertyDetail.stateName
	// 		);

	// 		metaKeywordsdd = metaKeywordsdd.replace(
	// 			cityName ? cityName : propertyDetail.cityName,
	// 			getCityName || propertyDetail.cityName
	// 		);
	// 		metaKeywordsdd = metaKeywordsdd.replace(
	// 			new RegExp(
	// 				propertyNamee ? propertyNamee : propertyDetail.propertyName,
	// 				'g'
	// 			),
	// 			propertyName || propertyDetail.propertyName
	// 		);

	// 		let metaDescriptionn = metaDescription || '';
	// 		metaDescriptionn = metaDescriptionn.replace(
	// 			new RegExp(
	// 				propertyNamee ? propertyNamee : propertyDetail.propertyName,
	// 				'g'
	// 			),
	// 			propertyName || propertyDetail.propertyName
	// 		);
	// 		metaDescriptionn = metaDescriptionn.replace(
	// 			cityName ? cityName : propertyDetail.cityName,
	// 			getCityName || propertyDetail.cityName
	// 		);
	// 		metaDescriptionn = metaDescriptionn.replace(
	// 			hotelORDharmshalaName
	// 				? hotelORDharmshalaName
	// 				: propertyDetail.propertyTypeName,
	// 			hotelORdharmshalaNamee || propertyDetail.propertyTypeName
	// 		);
	// 		form.setFieldsValue({
	// 			metaTitle: metaTitle
	// 				? metaTitle.replace(
	// 					new RegExp(
	// 						propertyNamee
	// 							? propertyNamee
	// 							: propertyDetail.propertyName,
	// 						'g'
	// 					),
	// 					propertyName || propertyDetail.propertyName
	// 				)
	// 				: '',
	// 			metaDescription: metaDescriptionn,
	// 			metaKeywords: metaKeywordsdd,
	// 		});
	// 		setPropertyName(propertyName);
	// 		setStateName(getStateName);
	// 		setCityName(getCityName);
	// 		setHotelORDharmshalaName(hotelORdharmshalaNamee);
	// 	}
	// };
	// useEffect(() => {
	// 	if (addModel === 'add') {
	// 		form.setFieldsValue(SEOData);
	// 	}
	// }, [SEOData, addModel]);

	const SubmitRoomCategory = (data) => {
		setDisabled(true);
		const payload = data.roomCategoryAddModels.map((category) => ({
			maxGuest: category.maxGuest,
			noOfRooms: category.noOfRooms,
			noofBathroom: category.noofBathroom,
			noofBed: category.noofBed,
			roomTitle: category.roomTitle,
			roomType: category.roomType,
			roomSize: category.roomSize,
			ePropertyId: propertyID,
			eAmenityId: category.eAmenityId,
			additionalBedCapacity: category.additionalBedCapacity,
		}));

		ACCOMMODATION.addRoomCategory(payload)
			.then((response) => {
				if (response.httpStatusCode === 200) {
					Notification.success({
						message: Message().CRUD.ADD('Room Category Detail'),
					});
					setCurrent(3);
					setFormID('RoomCategoryImageUpload');
					ACCOMMODATION.ReadRoomCategoryLookup(
						propertyID || propertyDetail.id
					);
					AUTH.getAllByLookupKeyList(
						`lookupKey=IMAGETYPE&isAdmin=false`
					);
				} else {
					Notification.error({
						message: response.message,
					});
				}
			})
			.catch((error) => {
				console.error('Error in API call:', error);
			})
			.finally(() => {
				setDisabled(false);
				setSaving(false);
			});
	};

	const handleAddPropertySubmit = (data) => {
		setSaving(true);
		data['checkIn'] = dayjs(data.checkIn).format(
			displayFormats.TIME_FORMAT
		);
		data['checkOut'] = dayjs(data.checkOut).format(
			displayFormats.TIME_FORMAT
		);
		// data['checkIn'] = moment(data.time[0]['$d']).format(
		// 	displayFormats.TIME_FORMAT
		// );
		// data['checkOut'] = moment(data.time[1]['$d']).format(
		// 	displayFormats.TIME_FORMAT
		// );
		// delete data.time;
		data.eMerchantId = props.merchantId;
		data.description = descriptionValue;
		// data.metaTitle = isChecked ? data.metaTitle : null;
		// data.metaKeywords = isChecked ? data.metaKeywords : null;
		// data.metaDescription = isChecked ? data.metaDescription : null;
		data.seoTitle = data.seoTitle || null;
		data.faQs = data.faqs && data.faqs.length ? JSON.stringify(data.faqs) : null;
		data.faQsSchema = data.faQsSchema?.replace(/(\r\n|\n|\r)/g, '') || null
		delete data.faqs
		ACCOMMODATION.addProperty(data)
			.then((data) => {
				if (typeof data !== 'string') {
					Notification.success({
						message: Message().CRUD.ADD('Property Detail'),
					});
					form.resetFields();
					setDescriptionValue('');
					// setfaQsValue('');
					setCurrent(1);
					setPropertyID(data.data);
					setFormID('PropertyImageUpload');
					setDisabled(true);
					AUTH.getAllByLookupKeyList(
						`lookupKey=IMAGETYPE&isAdmin=false`
					);
				} else {
					Notification.error({
						message: data,
					});
				}
			})
			.catch((e) => { })
			.finally(() => setSaving(false));
	};

	const handelEditPropertySubmit = async (data) => {
		setSaving(true);
		setDisabled(true);
		//property amenity
		const amenityPropertyMap = new Map(
			propertyDetail.propertyAmenityViewModel.map((item) => [
				item.eAmenityId,
				item,
			])
		);

		const tempPropertyArray = data.eAmenityId.map(
			(amenity) =>
				amenityPropertyMap.get(amenity) || {
					eAmenityId: amenity,
				}
		);
		const tempArrayPropertySet = new Set(data.eAmenityId);
		const deletedPropertyAmenity = propertyDetail.propertyAmenityViewModel
			.filter((item) => !tempArrayPropertySet.has(item.eAmenityId))
			.map((item) => ({ ...item, isActive: false }));
		data['eAmenityId'] = [...tempPropertyArray, ...deletedPropertyAmenity];

		//payload for property
		data['checkIn'] = dayjs(data.checkIn).format(
			displayFormats.TIME_FORMAT
		);
		data['checkOut'] = dayjs(data.checkOut).format(
			displayFormats.TIME_FORMAT
		);
		// data['checkIn'] = moment(data.time[0]['$d']).format(
		// 	displayFormats.TIME_FORMAT
		// );
		// data['checkOut'] = moment(data.time[1]['$d']).format(
		// 	displayFormats.TIME_FORMAT
		// );
		// delete data.time;
		let propertyPayload = {
			id: propertyDetail.id,
			eMerchantId: props.merchantId,
			propertyName: data.propertyName,
			eStateId: data.eStateId,
			eCityId: data.eCityId,
			description: descriptionValue,
			contactNo: data.contactNo,
			address: data.address,
			checkIn: data.checkIn,
			checkOut: data.checkOut,
			versionNo: propertyDetail.versionNo,
			isActive: propertyDetail.isActive,
			rating: data.rating,
			metaDescription: data.metaDescription,
			metaKeywords: data.metaKeywords,
			metaTitle: data.metaTitle,
			seoTitle: data.seoTitle || null,
			shortName: data.shortName,
			tdsCategory: data.tdsCategory,
			pan: data.pan,
			faQs: data.faqs.length ? JSON.stringify(data.faqs) : null,
			faQsSchema: data.faQsSchema?.replace(/(\r\n|\n|\r)/g, '') || null,
			propertyAmenityUpdateModel: [
				...tempPropertyArray,
				...deletedPropertyAmenity,
			],
		};
		delete data.faqs
		ACCOMMODATION.EditProperty({
			...propertyPayload,
		})
			.then(() => {
				Notification.success({
					message: Message().CRUD.UPDATE('Property Detail'),
				});
				form.resetFields();
				setDescriptionValue('');
				// setfaQsValue('');
				setDisabled(true);
				setCurrent(1);
				setFormID('PropertyImageUpload');
				setPropertyID(data.data);
				AUTH.getAllByLookupKeyList(`lookupKey=IMAGETYPE&isAdmin=false`);
				handleImageUploadScreen();

				setAccommodationStep((prev) => {
					const updatedArray = [...prev];
					updatedArray[0] = {
						...updatedArray[0],
						status: 'finish',
					};
					return updatedArray;
				});
			})
			.catch((e) => {
				// const errorData = ROOT.assignErrorToInput(e);
				// form.setFieldsValue({ error: errorData });
			})
			.finally(() => {
				setSaving(false);
				setDisabled(false);
			});
	};

	//for property table using merchant id
	useEffect(() => {
		ACCOMMODATION.getMerchantAccomodation(props.merchantId);
	}, [ACCOMMODATION]);

	//property image upload
	const PropertyImageUploadSubmit = async (data) => {
		setSaving(true);
		await data.propertyImageList.forEach(async (item) => {
			if (
				Object.keys(item).includes('fileList') &&
				Object.keys(item.fileList).length === 2
			) {
				const formData = new FormData();
				formData.append('RefTablename', 'property');

				formData.append(
					'ERefRecordid',
					propertyID || propertyDetail.id
				);
				Object.keys(item).forEach((keyName) => {
					if (['Description', 'ImageType'].includes(keyName)) {
						formData.append(keyName, item[keyName]);
					} else {
						formData.append(
							'Imagefile',
							item.fileList.fileList[0].originFileObj
						);
					}
				});
				await AUTH.ImageUpload(formData)
					.then((data) => {
						if (typeof data !== 'string') {
							console.log('done');
						} else {
							Notification.error({
								message: data,
							});
						}
					})
					.catch((e) => { })
					.finally(() => setSaving(false));
			}
		});
		Notification.info({ message: 'Image uploading start in background.' });
		// setTempleStep(templeSteps);
		setCurrent(2);
		setFormID('RoomCategoryForm');
		setPropertyID(propertyID || propertyDetail.id);
		setSaving(false);
		setDisabled(true);
		ACCOMMODATION.getRoomCategoryByProperty(
			propertyID || propertyDetail.id
		);
	};

	const RoomCategoryImageUploadSubmit = async (data) => {
		setSaving(true);
		await data.roomCategoryImageList.forEach(async (item) => {
			if (
				Object.keys(item).includes('fileList') &&
				Object.keys(item.fileList).length === 2
			) {
				const formData = new FormData();
				formData.append('RefTablename', 'roomcategory');
				formData.append('ERefRecordid', roomCategoryId);
				Object.keys(item).forEach((keyName) => {
					if (['Description', 'ImageType'].includes(keyName)) {
						formData.append(keyName, item[keyName]);
					} else {
						formData.append(
							'Imagefile',
							item.fileList.fileList[0].originFileObj
						);
					}
				});
				await AUTH.ImageUpload(formData)
					.then((data) => {
						if (typeof data !== 'string') {
							setCurrent(0);
						} else {
							Notification.error({
								message: data,
							});
						}
					})
					.catch((e) => { })
					.finally(() => setSaving(false));
			}
		});
		setCurrent(0);
		Notification.info({ message: 'Image uploading start in background.' });

		closeModal();
	};
	const closeModal = () => {
		form.resetFields();
		setDescriptionValue('');
		// setfaQsValue('');
		setPropertyName();
		setStateName();
		setCityName();
		setHotelORDharmshalaName();
		setDisabled(true);
		setFormID('PropertyForm');
		ACCOMMODATION.roomCategoryDetail = null;
		ACCOMMODATION.propertyDetail = null;
		AUTH.stateList = [];
		AUTH.cityList = [];
		AUTH.amenityList = [];
		ACCOMMODATION.merchantAccomodation = null;
		setAddModel(false);
		ACCOMMODATION.getMerchantAccomodation(props.merchantId);
		setFileLists({});
		ACCOMMODATION.roomCategoryImageDetails = null;
		setCurrent(0);
		ACCOMMODATION.roomcategorybyproperty = [];
		ACCOMMODATION.roomCategoryEditData = null;
		// setIsChecked(false);
	};

	const propertyModal = (type) => {
		setAddModel(type);
	};

	useEffect(() => {
		if (propertyDetail) {
			const checkInTime = propertyDetail.checkIn
				? dayjs(propertyDetail.checkIn, displayFormats.TIME_FORMAT)
				: null;
			const checkOutTime = propertyDetail.checkOut
				? dayjs(propertyDetail.checkOut, displayFormats.TIME_FORMAT)
				: null;

			const formData = {
				...propertyDetail,
				faqs: (propertyDetail.faQs && JSON.parse(propertyDetail.faQs)) ? JSON.parse(propertyDetail.faQs) : [{}],
				checkIn: checkInTime,
				checkOut: checkOutTime,
				eAmenityId:
					propertyDetail.propertyAmenityViewModel != null
						? propertyDetail.propertyAmenityViewModel
							.filter((_x) => _x.eAmenityId)
							.map((_x) => _x.eAmenityId)
						: null,

				// time: [checkInTime, checkOutTime],
			};
			form.setFieldsValue(formData);
			// if (formData.metaTitle || formData.metaDescription || formData.metaKeywords) {
			// 	setIsChecked(true)
			// }
			setDescriptionValue(formData.description);
			// setfaQsValue(formData.faQs);
		}
	}, [propertyDetail]);

	const columns = [
		{
			title: 'Property Name',
			dataIndex: 'propertyName',
			key: 'propertyName',
		},
		{
			title: 'Description',
			dataIndex: 'description',
			key: 'description',
			render: (text, rec) => {
				// Create a temporary div to parse the HTML
				const tempDiv = document.createElement('div');
				tempDiv.innerHTML = text; // Use 'text' as input here

				// Extract plain text from the temporary div
				const plainText = tempDiv.innerText
					.replace(/&nbsp;/g, ' ')
					.trim();

				// Truncate the text to 100 characters and append '...' if necessary
				const truncatedText =
					plainText.length > 100
						? plainText.slice(0, 100) + '...'
						: plainText;
				return (
					<div
						dangerouslySetInnerHTML={{
							__html: truncatedText,
						}}
					/>
				);
			},
		},
		{
			title: 'Address',
			dataIndex: 'address',
			key: 'address',
			render: (text, rec) => (
				<p>{text.length > 100 ? text.slice(0, 100) + '...' : text}</p>
			),
		},
		{
			title: 'Property Type',
			dataIndex: 'propertyType',
			key: 'propertyType',
		},
		{
			title: 'Image Approved',
			dataIndex: 'imageApproved',
			// key: 'imageApproved',
			render: (text, rec) => <p>{text ? 'True' : 'False'}</p>,
		},
		{
			title: 'Actions',
			key: 'actions',
			render: (text, props) => (
				<Space size="middle">
					<Button
						type="primary"
						className="addBtn"
						onClick={() => {
							ACCOMMODATION.ReadProperty(props.id);
							AUTH.getAllByLookupKeyList(
								`lookupKey=PROPERTYTYPE&isAdmin=false`
							);
							AUTH.getAllByLookupKeyList(
								'lookupKey=TDSCATEGORY&isAdmin=false'
							);
							setPropertyID(props.id);
							propertyModal('edit');
						}}
					>
						Edit
					</Button>
					<Button
						type="primary"
						className="addBtn"
						onClick={() => showDeleteModal(props)}
					>
						Delete
					</Button>
					<Button
						type="text"
						title={
							props.imageApproved
								? 'Approved'
								: 'Pending Approval'
						}
						//disabled={props.data.imageApproved}
						className="imgIcon"
						onClick={() => {
							ACCOMMODATION.ReadPropertyImagedetail({
								tableName: 'property',
								propertyID: props.id,
							});
							openImage(props);
						}}
					>
						<FontAwesomeIcon
							color={props.imageApproved ? '#ff6f00' : '#000'}
							icon={faImage}
						/>
					</Button>
				</Space>
			),
		},
	];

	// tab change in edit button
	const onTabChange = async (e) => {
		form.resetFields();
		setDescriptionValue('');
		// setfaQsValue('');
		ACCOMMODATION.roomCategoryEditData = null;
		SetRoomCategoryId(null);
		setCurrent(e);
		if (e === 1) {
			AUTH.getAllByLookupKeyList(`lookupKey=IMAGETYPE&isAdmin=false`);
			setFileLists({});
			await handleImageUploadScreen();
		} else if (e === 2) {
			ACCOMMODATION.getRoomCategoryByProperty(
				propertyID || propertyDetail.id
			);
			if (!roomCategoryDetail) {
				handleRoomCategorytabchange();
			}
		} else if (e === 3) {
			AUTH.getAllByLookupKeyList(`lookupKey=IMAGETYPE&isAdmin=false`);
			ACCOMMODATION.ReadRoomCategoryLookup(propertyDetail.id);
			setFileLists({});
			setFormID('RoomCategoryImageUpload');
			setCurrent(3);
			if (!roomCategoryImageDetails) {
				await handleImageUploadRoomCategoryScreen();
			}
		} else if (e === 0 && propertyDetail) {
			ACCOMMODATION.ReadProperty(propertyDetail.id);
			setFormID('PropertyForm');
			setPropertyID(propertyDetail.id);
			setCurrent(0);
			AUTH.getAllByLookupKeyList('lookupKey=PROPERTYTYPE&isAdmin=false');
			AUTH.getAllByLookupKeyList('lookupKey=TDSCATEGORY&isAdmin=false');
			if (propertyDetail) {
				const checkInTime = propertyDetail.checkIn
					? dayjs(propertyDetail.checkIn, displayFormats.TIME_FORMAT)
					: null;
				const checkOutTime = propertyDetail.checkOut
					? dayjs(propertyDetail.checkOut, displayFormats.TIME_FORMAT)
					: null;

				const formData = {
					...propertyDetail,
					checkIn: checkInTime,
					checkOut: checkOutTime,

					eAmenityId:
						propertyDetail.propertyAmenityViewModel != null
							? propertyDetail.propertyAmenityViewModel
								.filter((_x) => _x.eAmenityId)
								.map((_x) => _x.eAmenityId)
							: null,

					// time: [checkInTime, checkOutTime],
				};
				form.setFieldsValue(formData);
			}
		}
	};
	const handleRoomCategorytabchange = () => {
		setDisabled(true);
		setPropertyID(propertyDetail.id);
		setFormID('RoomCategoryForm');
		setCurrent(2);
	};

	const handleImageUploadScreen = async () => {
		setDisabled(true);
		let reqPayload = {
			tableName: 'property',
			propertyID: propertyID,
		};

		const propertyImageData =
			await ACCOMMODATION.ReadPropertyImagedetail(reqPayload);
		const propertyImageList = propertyImageData || [];
		const selectedImageTypes =
			propertyImageList.length &&
			propertyImageList
				.map((item) => item?.imageType)
				.filter((type) => type !== undefined && type !== null);
		if (selectedImageTypes) {
			setDisabledDefault(selectedImageTypes.includes(3) ? 3 : 0);
		}
		const newFileLists = {};
		await propertyImageData.forEach((item, index) => {
			newFileLists[index] = [
				{
					uid: item.id,
					name: item.filename,
					url: item.bunnyLink || URL.createObjectURL(item.bunnyLink),
					status: 'done', // e.g., done, uploading, error
				},
			];
		});
		setFileLists(newFileLists);
		const tempArray = [];
		await propertyImageData.forEach((_x, index) => {
			const tempObj = {};
			tempObj['Description'] = _x.description;
			tempObj['ImageType'] = _x.imageType;
			tempObj['fileList'] = [newFileLists[index]];
			tempArray.push(tempObj);
		});
		form.setFieldsValue({ propertyImageList: tempArray });
		setFormID('PropertyImageUpload');
		setCurrent(1);
	};

	const handleImageUploadRoomCategoryScreen = async () => {
		let reqPayload = {
			tableName: 'roomcategory',
			roomCategoryID: form.getFieldsValue().RoomCategoryId,
		};

		const roomCategoryImageData =
			await ACCOMMODATION.ReadRoomCategoryImagedetail(reqPayload);
		const newFileLists = {};

		const roomCategoryImageList = roomCategoryImageData || [];
		const selectedImageTypes =
			roomCategoryImageList.length &&
			roomCategoryImageList
				.map((item) => item?.imageType)
				.filter((type) => type !== undefined && type !== null);
		if (selectedImageTypes) {
			setDisabledDefault(selectedImageTypes.includes(3) ? 3 : 0);
		}

		if (roomCategoryImageData.length) {
			await roomCategoryImageData?.forEach((item, index) => {
				newFileLists[index] = [
					{
						uid: item.id,
						name: item.filename,
						url:
							item.bunnyLink ||
							URL.createObjectURL(item.bunnyLink),
						status: 'done', // e.g., done, uploading, error
					},
				];
			});

			setFileLists(newFileLists);
			const tempArray = [];
			await roomCategoryImageData?.forEach((_x, index) => {
				const tempObj = {};
				tempObj['Description'] = _x.description;
				tempObj['ImageType'] = _x.imageType;
				tempObj['fileList'] = [newFileLists[index]];
				tempArray.push(tempObj);
			});
			form.setFieldsValue({ roomCategoryImageList: tempArray });

			setDisabled(true);
		} else {
			form.setFieldsValue({ roomCategoryImageList: [] });
		}
	};

	return (
		<>
			<Button
				key={1}
				type="primary"
				className="addBtn"
				onClick={() => propertyModal('add')}
			>
				Add Property
			</Button>
			<Table
				dataSource={ACCOMMODATION.merchantAccomodation}
				columns={columns}
				pagination={false}
			/>
			<DeletePropertyComponent
				visible={isDeleteModalVisible}
				onClose={handleDeleteModalClose}
				merchantId={props}
			/>
			<PropertyImageApproveModal
				visible={propertyImageModal}
				onClose={closeImageModal}
				merchantId={props}
			/>
			<Drawer
				title={`${addModel === 'add' ? 'Add' : 'Update'} Property and Room Category`}
				onClose={closeModal}
				open={addModel}
				destroyOnClose
				width={'82%'}
				footer={
					// formID === 'RoomCategoryForm' &&
					// addModel !== 'add' ? null : (
					<div style={{ textAlign: 'right' }} id="footer">
						{!ACCOMMODATION.roomCategoryEditData && (
							<Button
								key={2}
								type="primary"
								disabled={disabled}
								htmlType="submit"
								form={formID}
								loading={saving}
							>
								Submit
							</Button>
						)}
						<Button
							key={3}
							onClick={closeModal}
							style={{ marginLeft: '20px' }}
						>
							Cancel
						</Button>
					</div>
					// )
				}
			>
				<Steps
					items={PropertySteps}
					current={current}
					onChange={(e) => {
						addModel !== 'add'
							? onTabChange(e)
							: console.log('fill form data');
					}}
					style={{
						marginBottom: 24,
					}}
				/>
				{current === 0 ? (
					<PropertyComponent
						id="PropertyForm"
						form={form}
						descriptionValue={descriptionValue}
						setDescriptionValue={(data) => {
							setDescriptionValue(data);
							handleChange();
						}}
						// faQsValue={faQsValue}
						// onFaqChange={(data) => {
						// 	setfaQsValue(data);
						// 	handleChange();
						// }}
						onFinish={
							addModel === 'add'
								? handleAddPropertySubmit
								: handelEditPropertySubmit
						}
						handleChange={handleChange}
						// testBlurEv={testBlurEv}
						addModel={addModel}
					// isChecked={isChecked}
					// setIsChecked={setIsChecked}
					/>
				) : // </Spin>
					current === 1 ? (
						<PropertyImageUpload
							id="PropertyImageUpload"
							form={form}
							onFinish={
								addModel === 'add'
									? PropertyImageUploadSubmit
									: PropertyImageUploadSubmit
							}
							handleChange={handleChange}
							fileLists={fileLists}
							setFileLists={setFileLists}
							disabledDefault={disabledDefault}
						/>
					) : // </Spin>
						current === 2 ? (
							<RoomCategoryForm
								id="RoomCategoryForm"
								form={form}
								onFinish={SubmitRoomCategory}
								handleChange={handleChange}
								initialValues={{ roomCategoryAddModels: [{}] }}
								propertyID={propertyID}
								disable={disabled}
							/>
						) : // </Spin>
							current === 3 ? (
								<RoomCategoryImageUpload
									id="RoomCategoryImageUpload"
									form={form}
									onFinish={RoomCategoryImageUploadSubmit}
									handleChange={handleChange}
									fileLists={fileLists}
									setFileLists={setFileLists}
									disabledDefault={disabledDefault}
								/>
							) : null}
			</Drawer>
		</>
	);
});
export default AddAccommodationDetail;
